import PropTypes from "prop-types";
import React, { useContext } from "react";

import { Dialog, Layout, useDialog } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

import { MfaContext } from "../../MfaProvider";
import { MfaAuthorizer } from "../MfaAuthorizer";
import styles from "./MfaProtected.module.scss";

/**
 * MfaProtected will MFA verify the user before rendering the children.
 */
export const MfaProtected = (props) => {
  const { children, onAuthorized, onClose, mfaServices, restoreFocus } = props;
  const { mfaAuthenticated, mfaRequired } = useContext(MfaContext);

  const { hideDialog, isDialogVisible } = useDialog(
    "center",
    shouldShowDialog() ? "above" : "hidden",
    undefined,
    restoreFocus
  );

  return (
    <div>
      {isDialogVisible && (
        <Dialog {...getDialogProps()}>
          <Layout top="none" left="medium" right="medium">
            <MfaAuthorizer
              mfaServices={mfaServices}
              onAuthorized={handleAuthorized}
              onError={handleClose}
            />
          </Layout>
        </Dialog>
      )}
      {!isDialogVisible && children}
    </div>
  );

  function shouldShowDialog() {
    return !mfaAuthenticated && mfaRequired;
  }

  function getDialogProps() {
    return {
      "aria-label-close": i18n("Accessibility__DIALOG_MODAL_CLOSE"),
      buttonGroupProps: {
        "aria-label-next": i18n("MfaProtected__BUTTON_GROUP_ARIA_NEXT"),
        "aria-label-previous": i18n("MfaProtected__BUTTON_GROUP_ARIA_PREVIOUS"),
      },
      className: styles.dialog,
      onClose: handleClose,
      portal: false,
      revealed: isDialogVisible,
      showClose: true,
      width: "small",
    };
  }

  function handleClose() {
    hideDialog();
    onClose?.();
  }

  function handleAuthorized() {
    onAuthorized?.();
    hideDialog();
  }
};

MfaProtected.propTypes = {
  /** Content that will be rendered. */
  children: PropTypes.node.isRequired,
};
